import { Injectable, NgZone } from '@angular/core';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';


@Injectable({
  providedIn: 'root'
})

export class UserSocketService {
  private socket: any

  constructor(
    private authenticationService: AuthenticationService,
    private ngZone: NgZone
  ) {
    this.authenticationService.currentUser.subscribe(currentUser => {
      // Checking If User is Logged IN
      if (currentUser) {
        this.ngZone.runOutsideAngular(() => {
          this.socket = io.connect(environment.ioSocketUrl, {
            transports: ['websocket'],
            query: {
              globalUserId: currentUser._id,
            },
            reconnection: true
          });
        });
      } else {
        if (this.socket) {
          this.socket.disconnect();
        }
      }
    });
  }

  // Events names -> Gets emitted from backend
  on(event: string) {
    return new Observable(observer => {
      this.socket.on(event, data => {
        observer.next(data);
      });
    });
  }
}
